import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { MentorMappingGridDataService } from 'common/services/data-services/admin/mentor/mentor-map-grid-data.service';
import { MentorMappingGridMetaModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-grid-meta-model';
import { MentorMappingListingModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-grid-model';
import { MentorMappingModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-model';
import { environment } from 'src/environments/environment';
import { API_URL } from 'common/constants/sm-constants';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { MentorMappingListDataService } from 'common/services/data-services/custom-service/mentor-list-service';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { IsEmailSendDataService } from 'common/services/data-services/admin/mentor/isEmailSend-data.service';


 
@Injectable({
    providedIn: 'root'
})
export class MentorMappingGridWidgetService extends GridWidgetService<MentorMappingModel, MentorMappingListingModel> {
    constructor(
        protected override ds: MentorMappingGridDataService,
        protected systemService: SystemService,
        private branchList: branchListDataService,
        private batchListService: BatchListDataService,
        protected mentorList: MentorMappingListDataService,
        private isEmailSent:IsEmailSendDataService

      ) {
        super(ds);
      }
    
      getMetaModel(): MetaModel {
        const meta = new MentorMappingGridMetaModel().getMetaModel();
        return meta;
      }
    
      override prepareMetaModel(
        dataModel: MentorMappingModel,
        metaModel: MentorMappingGridMetaModel,
        routeData: WidgetModel
      ): Promise<MentorMappingGridMetaModel> {
        return new Promise<MentorMappingGridMetaModel>((resolve, reject) => {
          // console.log(routeData);
    
          this.mentorList.postData({}).then((data) => {
            // console.log(data);
            routeData.transferData.filterMeta.properties.mentor_name.options =
              data.details;
          });
          
          this.branchList.postData({}).then((data) => {
            routeData.transferData.filterMeta.properties.branch.options =
              data.details;
          });
          this.batchListService.postData("").then((data) => {
            routeData.transferData.filterMeta.properties.batch.options =
              data.details;
          });
          resolve(metaModel);
        });
      }
    
    notifyStudents(payload) {
        this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.notifyStudentForAssignedMentor).then((data) => {
            this.systemService.showSuccess(data['msg'])
        })
    }

    async isEmailSended(payload: any): Promise<any> {

      return await new Promise((resolve, reject) => {
        this.isEmailSent
          .postData(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
}